import { ParsedUrlQuery } from "querystring";

function serializeParseUrlQuery(query: ParsedUrlQuery): string {
  if (!query || Object.entries.length <= 0) {
    return "";
  }

  const search = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    search.append(key, `${value}`);
  });
  return search.toString();
}

export default {
  serializeParseUrlQuery,
};
